<script lang="ts" module>
	import type { Snippet } from 'svelte';
	import type { ClassValue, HTMLAttributes } from 'svelte/elements';
	import { tv } from '../tv';

	export const avatarFallbackVariants = tv({
		base: 'absolute inline-flex size-full items-center justify-center rounded-[inherit]'
	});

	export type AvatarFallbackProps = Omit<HTMLAttributes<HTMLSpanElement>, 'class' | 'children'> & {
		children?: Snippet;
		class?: ClassValue;
		ref?: HTMLSpanElement | null;
	};
</script>

<script lang="ts">
	let {
		children,
		class: className,
		ref = $bindable(null),
		...rest
	}: AvatarFallbackProps = $props();
</script>

<span bind:this={ref} class={[avatarFallbackVariants(), className]} {...rest}>
	{@render children?.()}
</span>
